import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from "@angular/core";

@Directive({ standalone: false, selector: "[fxFlexAlign]" })
export class FxFlexAlignDirective implements OnChanges {
  @Input() fxFlexAlign?: string;
  constructor(private readonly host: ElementRef<HTMLElement>, private readonly renderer: Renderer2) {}
  ngOnChanges(_: SimpleChanges): void {
    const value = (this.fxFlexAlign || "").trim().toLowerCase();
    const align = value === "center" ? "center" : value === "end" ? "flex-end" : value === "stretch" ? "stretch" : value === "baseline" ? "baseline" : "flex-start";
    this.renderer.setStyle(this.host.nativeElement, "align-self", align);
  }
}
